import React from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown.ts';
import { ColorScheme } from '../constants/colors.ts';
import { fadeIn } from '../constants/animations.ts';

interface CountdownSectionProps {
  weddingDate: Date;
  colors: ColorScheme;
}

const CountdownSection: React.FC<CountdownSectionProps> = ({ weddingDate, colors }) => {
  const timeLeft = useCountdown(weddingDate);

  return (
    <motion.section 
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={fadeIn}
      className="py-20 relative overflow-hidden"
      style={{ 
        background: `linear-gradient(135deg, ${colors.gradientStart} 0%, ${colors.gradientEnd} 100%)`,
        color: colors.text 
      }}
    >
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-full h-full pattern-bg opacity-20"></div>
      </div>
      
      <h2 className="font-optima text-xl text-center mb-10 tracking-[0.2em] uppercase" style={{ color: colors.accent }}>Counting Down</h2>
      <div className="grid grid-cols-4 gap-4 max-w-xs mx-auto px-4">
        <div className="text-center">
          <div className="font-optima text-4xl font-medium mb-2" style={{ color: colors.text }}>{timeLeft.days}</div>
          <div className="font-optima text-xs tracking-wider uppercase" style={{ color: colors.textLight }}>Days</div>
        </div>
        <div className="text-center">
          <div className="font-optima text-4xl font-medium mb-2" style={{ color: colors.text }}>{timeLeft.hours}</div>
          <div className="font-optima text-xs tracking-wider uppercase" style={{ color: colors.textLight }}>Hours</div>
        </div>
        <div className="text-center">
          <div className="font-optima text-4xl font-medium mb-2" style={{ color: colors.text }}>{timeLeft.minutes}</div>
          <div className="font-optima text-xs tracking-wider uppercase" style={{ color: colors.textLight }}>Minutes</div>
        </div>
        <div className="text-center">
          <div className="font-optima text-4xl font-medium mb-2" style={{ color: colors.text }}>{timeLeft.seconds}</div>
          <div className="font-optima text-xs tracking-wider uppercase" style={{ color: colors.textLight }}>Seconds</div>
        </div>
      </div>
    </motion.section>
  );
};

export default CountdownSection;
